import { Helmet } from 'react-helmet-async';
import { useState, useCallback, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
// @mui
import {
    Card,
    Table,
    Stack,
    Paper,
    Button,
    Pagination,
    TableRow,
    TableBody,
    TableCell,
    Typography,
    FormGroup,
    FormControlLabel,
    TableContainer,
    Checkbox,
    CircularProgress,
    Chip
} from '@mui/material';

// components
import Iconify from '../components/iconify';


// hooks

import { useAxios } from '../context/AxiosHookContext';

// sections
import { UserListHead, UserListToolbar } from '../sections/@dashboard/user';


// ----------------------------------------------------------------------

const TABLE_HEAD = [
    { id: 'reviewed', label: 'Estado', alignRight: false },
    { id: 'name', label: 'Código', alignRight: false },
    { id: 'name', label: 'Autor', alignRight: false },
    { id: 'name', label: 'Cédula', alignRight: false },
    { id: 'name', label: 'Teléfono', alignRight: false },
    { id: 'name', label: 'Correo', alignRight: false },
    { id: 'name', label: 'Coautor', alignRight: false },
    { id: 'name', label: 'Coautor Cédula', alignRight: false },
    { id: 'name', label: 'Coautor Teléfono', alignRight: false },
    { id: 'name', label: 'PDF Identificación', alignRight: false },
    { id: 'name', label: 'PDF Autobiografía', alignRight: false },
    { id: 'name', label: 'PDF Carta certificación', alignRight: false },
    { id: '' }
];

// ----------------------------------------------------------------------

export default function EnrollmentDetailsPage() {
    const navigate = useNavigate();
    const { state } = useLocation()

    const [filterName, setFilterName] = useState('');
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1)
    const [loading, setLoading] = useState(false)
    const [enrollmentList, setenrollmentList] = useState([])
    const [loadingExcelReport, setLoadingExcelReport] = useState(false);
    const [filterCode, setFilterCode] = useState('')
    const [filterMail, setFilterMail] = useState('')
    const [filled,setfilled] = useState(true)
    const [reviewedFilter, setReviewedFilter] = useState(null)

    if (!state) {
        navigate("/enrollment")
    }

    const query =  `?page=${page}&limit=10&nombre=${filterName}&enrollmentId=${state._id}&cedula=${filterCode}&correo=${filterMail}&filled=${filled}${reviewedFilter !== null ? `&reviewed=${reviewedFilter}` : ''}`;

    const enrollmentApi = `/enrollment/enrollmentParticipants${query}`
    const axios = useAxios();



    const getInvitations = useCallback(async () => {
        try {
            setenrollmentList([])
            setLoading(true);
            const { data } = await axios.get(enrollmentApi);
            setenrollmentList(data.data.list);
            setTotalPages(data.data.total_pages)

        } catch (error) {
            console.log(error);
        } finally {
            setLoading(false);
        }
    }, [axios, enrollmentApi, setenrollmentList, setLoading,filled,reviewedFilter]);

    const markAsReviewed = async (participantId) => {
        try {
            await axios.put(`/enrollment/participant/${participantId}/mark-reviewed`);
            getInvitations();
        } catch (error) {
            console.log(error);
        }
    };


    const getExcelReport = useCallback(async () => {
        try {

            setLoadingExcelReport(true);
            const response = await axios.get(`/enrollment/report_excel${query}`, {
                responseType: 'blob' // Indica que esperas una respuesta de tipo Blob
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));

            const a = document.createElement('a');
            a.href = url;
            a.download = `reporte.xlsx`; // Nombre del archivo para descargar
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

        } catch (error) {
            console.log(error);
        } finally {
            setLoadingExcelReport(false)
        }
    }, [axios,query,filled]);

    useEffect(() => {
        getInvitations();
    }, [getInvitations])


    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleFilterByName = (event) => {
        setPage(1);
        setFilterName(event.target.value);
    };

    const handleFilterByMail = (event) => {
        setPage(1);
        setFilterMail(event.target.value);
    };

    const handleFilterByCode = (event) => {
        setPage(1);
        setFilterCode(event.target.value);
    };


    const handleFilled = (value) => {
        setPage(1);
        setfilled(value);
    };

    const handleReviewedFilter = (value) => {
        setPage(1);
        setReviewedFilter(value);
    };

    

    return (
        <>
            <Helmet>
                <title>{state.description} | {process.env.REACT_APP_APP_NAME} </title>
            </Helmet>

            <Stack direction="row" alignItems="center" justifyContent="space-between" mb={5}>
                <Typography variant="h4" gutterBottom>
                    {state.description}
                </Typography>
                <Button onClick={getExcelReport} variant="contained" startIcon={loadingExcelReport ? <CircularProgress size={'15px'} sx={{ color: 'white', marginRight: '6px' }} /> : <Iconify icon="file-icons:microsoft-excel" />}>
                    {loadingExcelReport ? "Exportando detalle" : "Exportar detalle"}
                </Button>
            </Stack>

            <Card>

                <Stack direction={"row"} alignItems="center">
                    <UserListToolbar filterName={filterName} onFilterName={handleFilterByName} label="Nombre" />
                    <UserListToolbar filterName={filterMail} onFilterName={handleFilterByMail} label="Correo" />
                    <UserListToolbar filterName={filterCode} onFilterName={handleFilterByCode} label="Cédula" />
                
                        <FormGroup>
                            <FormControlLabel control={<Checkbox value={filled} checked={filled} onChange={(e) => {
                                handleFilled(Boolean(e.target.checked))
                            }} />} label="Formularios validos" />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={reviewedFilter === false} onChange={(e) => {
                                handleReviewedFilter(e.target.checked ? false : null)
                            }} />} label="Pendiente de revisar" />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel control={<Checkbox checked={reviewedFilter === true} onChange={(e) => {
                                handleReviewedFilter(e.target.checked ? true : null)
                            }} />} label="Revisado" />
                        </FormGroup>
            
                </Stack>

                <TableContainer sx={{ minWidth: 800 }}>
                    <Table>
                        <UserListHead
                            headLabel={TABLE_HEAD}
                        />
                        <TableBody>
                            {enrollmentList?.map((row) =>

                            (
                                <TableRow hover key={row._id} tabIndex={-1} role="checkbox">

                                    <TableCell component="th" scope="row" padding="normal">
                                        {row.reviewed ? (
                                            <Chip 
                                                icon={<CheckCircleIcon />}
                                                label="Revisado" 
                                                color="success" 
                                                size="small"
                                            />
                                        ) : (
                                            <Button
                                                variant="contained"
                                                color="warning"
                                                size="small"
                                                startIcon={<PendingIcon />}
                                                onClick={() => markAsReviewed(row._id)}
                                                sx={{ fontWeight: 'bold' }}
                                            >
                                                Marcar Revisado
                                            </Button>
                                        )}
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {row.enrollment}
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {`${row.nombre} ${row.apellido}`}
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {row.cedula}
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {row.telefono}
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {row.correo}
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {
                                                row.coautor?.nombre ?
                                                    `${row.coautor?.nombre} ${row.coautor?.apellido}` :
                                                    'N/A'
                                            }
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {row.coautor?.cedula || "N/A"}
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {row.coautor?.telefono || "N/A"}
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {
                                                row.documentoIdentidad ?
                                                    <FolderCopyIcon sx={{ cursor: "pointer" }}
                                                        onClick={() => window.open(`${process.env.REACT_APP_API_FULL_DOMAIN}${row.documentoIdentidad}`, "_blank")}
                                                    /> : "N/A"
                                            }
                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {
                                                row.autobiografia ?
                                                    <FolderCopyIcon sx={{ cursor: "pointer" }}
                                                        onClick={() => window.open(`${process.env.REACT_APP_API_FULL_DOMAIN}${row.autobiografia}`, "_blank")}
                                                    /> : "N/A"
                                            }

                                        </Typography>
                                    </TableCell>

                                    <TableCell component="th" scope="row" padding="normal">
                                        <Typography variant="subtitle2" noWrap>
                                            {
                                                row.certificacionUni ?
                                                    <FolderCopyIcon sx={{ cursor: "pointer" }}
                                                        onClick={() => window.open(`${process.env.REACT_APP_API_FULL_DOMAIN}${row.certificacionUni}`, "_blank")}
                                                    /> : "N/A"
                                            }
                                        </Typography>
                                    </TableCell>


                                </TableRow>
                            ))}

                        </TableBody>

                        {
                            loading === true &&
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={11} sx={{ py: 3 }}>
                                        <Paper
                                            sx={{
                                                textAlign: 'center',
                                            }}
                                        >

                                            <CircularProgress size={"30px"} sx={{ color: "#aa9e97", marginRight: "auto", marginLeft: "auto" }} />

                                        </Paper>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        }

                        {
                            (enrollmentList.length === 0 && loading === false) &&
                            <TableBody>
                                <TableRow>
                                    <TableCell align="center" colSpan={11} sx={{ py: 3 }}>
                                        <Paper
                                            sx={{
                                                textAlign: 'center',
                                            }}
                                        >

                                            <Typography variant="h6" paragraph>
                                                Sin resultados
                                            </Typography>

                                            <Typography variant="body2">
                                                No se encontraron resultados para
                                                <br /> Intente con otra búsqueda.
                                            </Typography>
                                        </Paper>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        }

                    </Table>
                </TableContainer>

                <Pagination
                    count={totalPages}
                    page={page}
                    onChange={handleChangePage}

                    sx={{ float: "right", margin: 2, color: "#ffe7d9" }}
                />

            </Card>

        </>
    );
}
